import styled from 'styled-components'

export const WysiwygWrapper = styled.div`
  * {
    outline: none;
  }
`
